import { request } from "../libs/request";
import { COLOR_TAG } from "../enums/ColorTag";
import { ERequestMethods } from "../enums/RequestMethod";
import { CreateColorTagDto, IColorTag } from "../types/ColorTag";
import { IResponseData, ListResponseData } from "../types/requests";

function getColorTags() {
  return request<ListResponseData<IColorTag>>({
    method: ERequestMethods.GET,
    url: COLOR_TAG.MAIN,
  });
}

function getColorTagById(id: string) {
  return request<IResponseData<IColorTag>>({
    method: ERequestMethods.GET,
    url: `${COLOR_TAG.MAIN}/${id}`,
  });
}

function createColorTag(data: CreateColorTagDto) {
  return request({
    method: ERequestMethods.POST,
    url: COLOR_TAG.MAIN,
    data,
  });
}

function updateColorTag(
  id: string,
  data: Pick<IColorTag, "description" | "name" | "color">
) {
  return request({
    method: ERequestMethods.PATCH,
    url: `${COLOR_TAG.MAIN}/${id}`,
    data,
  });
}

function deleteColorTag(id: string) {
  return request({
    method: ERequestMethods.DELETE,
    url: `${COLOR_TAG.MAIN}/${id}`,
  });
}

const ColorTagRepository = Object.freeze({
  getColorTags,
  getColorTagById,
  createColorTag,
  updateColorTag,
  deleteColorTag,
});

export default ColorTagRepository;
